<template>
  <div class="large">
    <v-container grid-list-md>
      <v-banner single-line color="light-blue darken-4" dark>
        <!-- <v-icon slot="icon" size="36"> fa-exclamation-circle </v-icon> -->
        <span v-if="!this.athleteId"
          >To get information about the performance of an athlete,<br />
          use athlete settings</span
        >
        <span
          style="color: #ffe5b4; font-weight: bold"
          v-if="this.athleteId"
          color="red"
          >{{
            getfirstName() +
            " performance report From " +
            this.fromDate +
            " To " +
            this.toDate
          }}</span
        >
        <v-spacer></v-spacer>
        <template v-slot:actions>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            :nudge-bottom="11"
            offset-y
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined v-bind="attrs" v-on="on">
                <v-icon left>tune</v-icon>
                Athlete settings
              </v-btn>
              <v-btn
                v-show="false"
                color="secondary"
                text
                @click="showResults()"
                >Show Results</v-btn
              >
            </template>
            <v-card>
              <v-list>
                <v-list-item>
                  <!--v-list-item-avatar v-if="getCurrentData.length > 0">
                    {{ this.getCurrentData.node.firstName[0] }}
                  </v-list-item-avatar-->
                  <v-list-item-content>
                    <v-list-item-title class="mb-4">
                      Fill in the athlete and date fields to view performance
                      data.
                    </v-list-item-title>
                    <v-flex xs10 class="mx-auto mb-4">
                      <!-- <AthletesDropdown
                        v-on:parentValueChange="onChangeAthlete"
                        v-model.trim="athleteId"
                        :key="athleteKey"
                        :mode="'PERF'"
                      /> -->
                      <AthletesDropdown
                        v-on:parentValueChange="onChangeAthlete"
                        :parent-value="parentAthleteId"
                        :mode="'PERF'"
                      />
                    </v-flex>
                    <v-flex xs10 class="mx-auto mb-4">
                      <catValueDropDown
                        :outlined="true"
                        :catName="'SWIMMING_FACILITY'"
                        v-model.trim="facilityType"
                        label="Facility Type"
                        v-on:parentValListChange="onChangeFacility"
                      />
                    </v-flex>

                    <v-flex xs10 class="mx-auto mb-4">
                      <DateRange
                        class="mt-8 mt-sm-5"
                        :parent-from-date="parentFromDate"
                        :parent-to-date="parentToDate"
                        @change-fromDate="onChangeFromDate"
                        @change-toDate="onChangeToDate"
                      />
                    </v-flex>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-banner>
      <v-layout row wrap>
        <v-flex xs12 lg6>
          <line-chart
            :chart-data="this.datacollection"
            :options="options"
            stroke="FREESTYLE"
          ></line-chart>
        </v-flex>
        <v-flex xs12 lg6>
          <v-spacer></v-spacer>
          <line-chart
            :chart-data="this.datacollectionFly"
            :options="options"
            stroke="BUTTERFLY"
          ></line-chart>
        </v-flex>
        <v-flex xs12 lg6>
          <v-spacer></v-spacer>
          <line-chart
            :chart-data="this.datacollectionBack"
            :options="options"
            stroke="BACKSTROKE"
          ></line-chart>
        </v-flex>
        <v-flex xs12 lg6>
          <v-spacer></v-spacer>
          <line-chart
            :chart-data="this.datacollectionBreast"
            :options="options"
            stroke="BREASTROKE"
          ></line-chart>
        </v-flex>
        <v-flex xs12 lg6>
          <v-spacer></v-spacer>
          <line-chart
            :chart-data="this.datacollectionIm"
            :options="options"
            stroke="INDIVIDUAL MEDLEY"
          ></line-chart>
        </v-flex>
        <v-flex xs12 lg6>
          <v-spacer></v-spacer>
          <radar-chart
            :chart-data="this.datacollectionRadar"
            :options="options"
          ></radar-chart>
        </v-flex>
        <v-flex xs12 lg6>
          <v-divider class="flex-grow-1 mr-3"></v-divider>
          <span class="headline font-weight-bold text-uppercase"
            >Results History</span
          >
          <v-divider class="flex-grow-1 ml-3"></v-divider>
        </v-flex>
        <v-flex xs12 lg12>
          <v-spacer></v-spacer>
          <AthleteRanksResults
            :initAthleteId="this.athleteId"
            :fromDate="this.fromDate"
            :toDate="this.toDate"
            :localZenMode="true"
            :activeStatus="false"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LineChart from "../../constants/LineChart.js";
import RadarChart from "../../constants/RadarChart.js";
import AthletesDropdown from "../../shared/athletes_dropdown.vue";
import DateRange from "../../shared/date_range_from_to.vue";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";
import AthleteRanksResults from "../club/AthleteRanksResults.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    LineChart,
    RadarChart,
    AthletesDropdown,
    DateRange,
    catValueDropDown,
    AthleteRanksResults,
  },
  props: {
    stroke: {
      type: String,
      default: "FREE",
    },
  },
  data() {
    return {
      athleteId: null,
      parentAthleteId: null,
      parentFromDate: null,
      parentToDate: null,
      fromDate: "2010-01-01",
      toDate: new Date().toISOString().substr(0, 10),
      menu: false,
      facilityType: "25m",
      datacollection: null,
      datacollectionFree: null,
      datacollectionFly: null,
      datacollectionBack: null,
      datacollectionBreast: null,
      datacollectionIm: null,
      datacollectionRadar: null,
      options: null,
      athleteKey: 0,
    };
  },

  created() {
    if (!(Object.entries(this.$route.query).length === 0)) {
      const { facilityType, athleteId, fromDate, toDate } = this.$route.query;
      //assign to current instance variables
      if (facilityType) {
        this.facilityType = facilityType;
      }
      if (athleteId) {
        this.athleteId = athleteId;
        this.parentAthleteId = this.athleteId;
      }
      if (fromDate) {
        this.fromDate = fromDate;
        this.parentFromDate = this.fromDate;
      }
      if (toDate) {
        this.toDate = toDate;
        this.parentToDate = this.toDate;
      }
    }
    this.handleGetAthleteResults();
  },

  computed: {
    ...mapGetters(["athleteOfficialResults"]),
  },
  watch: {
    "$route.params.club": function () {
      this.handleGetAthleteResults();
    },
  },

  methods: {
    async showResults() {
      await this.fillData();
      console.log("test1");
    },

    async onChangeFacility(value) {
      this.facilityType = value;
      await this.fillData();
    },
    async onChangeAthlete(value) {
      // console.log(value);
      this.athleteId = value;
      await this.fillData();
    },
    async onChangeFromDate(value) {
      this.fromDate = value;
      await this.fillData();
    },
    async onChangeToDate(value) {
      this.toDate = value;
      await this.fillData();
    },
    getfirstName() {
      console.log(this.athleteOfficialResults);
      var athlete = this.athleteOfficialResults.filter(
        (item) => item.node.athleteId == this.athleteId
      )[0].node.athlete;
      return athlete.firstName + " " + athlete.lastName + "(" + athlete.birthDate + ")";
    },

    handleGetAthleteResults() {
      //reach out of Vuex store, fire action that gets athlete results
      // if (
      //   this.athleteOfficialResults === undefined ||
      //   this.athleteOfficialResults.length == 0
      // ) {

      this.$store.dispatch("allResults", {
        clubId: this.$route.params.club,
      });
      this.athleteKey += 1;
      //this.fillData();
      //}
    },
    getDataSet: function (
      athleteId,
      stroke,
      distance,
      facilityType,
      fromDate,
      toDate
    ) {
      // console.log(toDate);
      // console.log(this.athleteOfficialResults);
      return this.athleteOfficialResults
        .reduce(function (all, item) {
          if (
            item.node.athleteId == athleteId &&
            item.node.set &&
            (item.node.set.stroke == stroke || !stroke) &&
            (item.node.set.distance == distance || !distance) &&
            item.node.facilityType == facilityType &&
            item.node.resultDate >= fromDate &&
            item.node.resultDate <= toDate
          ) {
            var newItem = {
              x: item.node.resultDate,
              y:
                item.node.resultTime.split(":").reduce(function (seconds, v) {
                  //

                  return +v + seconds * 60;
                }, 0) / 60,
              comments: item.node.comments,
              athleteId: item.node.athleteId,
              distance: item.node.set.distance,
              stroke: item.node.set.stroke,
            };
            all.push(newItem);
          }
          return all;
        }, [])
        .sort(function (a, b) {
          // Sort by Date  -  Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.x) - new Date(a.x);
        });
    },

    fillData() {
      // RADAR CHART SECTION / CREATE ARRAY TO POPULATE CHART
      var resultsGroup25m = this.getDataSet(
        this.athleteId,
        null,
        null,
        "25m",
        this.fromDate,
        this.toDate
      ).reduce((p, c) => {
        var stroke = c.stroke;
        if (!p.hasOwnProperty(stroke)) {
          p[stroke] = 0;
        }
        p[stroke]++;
        return p;
      }, []);
      var resultsGroup25y = this.getDataSet(
        this.athleteId,
        null,
        null,
        "25y",
        this.fromDate,
        this.toDate
      ).reduce((p, c) => {
        var stroke = c.stroke;
        if (!p.hasOwnProperty(stroke)) {
          p[stroke] = 0;
        }
        p[stroke]++;
        return p;
      }, []);
      var resultsGroup50m = this.getDataSet(
        this.athleteId,
        null,
        null,
        "50m",
        this.fromDate,
        this.toDate
      ).reduce((p, c) => {
        var stroke = c.stroke;
        if (!p.hasOwnProperty(stroke)) {
          p[stroke] = 0;
        }
        p[stroke]++;
        return p;
      }, []);

      (this.datacollectionRadar = {
        labels: ["FREE", "BACK", "BREAST", "FLY", "MEDLEY"],
        datasets: [
          {
            label: "25meters",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            borderColor: "rgb(255, 99, 132)",
            pointBackgroundColor: "rgb(255, 99, 132)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgb(255, 99, 132)",
            fill: true,
            data: [
              resultsGroup25m.FREE,
              resultsGroup25m.BACK,
              resultsGroup25m.BREAST,
              resultsGroup25m.FLY,
              resultsGroup25m.MEDLEY,
            ],
          },
          {
            label: "50meters",
            fill: true,
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            borderColor: "rgb(54, 162, 235)",
            pointBackgroundColor: "rgb(54, 162, 235)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgb(54, 162, 235)",
            data: [
              resultsGroup50m.FREE,
              resultsGroup50m.BACK,
              resultsGroup50m.BREAST,
              resultsGroup50m.FLY,
              resultsGroup50m.MEDLEY,
            ],
          },
          {
            label: "25yards",
            fill: true,
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            borderColor: "yellow",
            pointBackgroundColor: "rgb(54, 162, 235)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgb(54, 162, 235)",
            data: [
              resultsGroup25y.FREE,
              resultsGroup25y.BACK,
              resultsGroup25y.BREAST,
              resultsGroup25y.FLY,
              resultsGroup25y.MEDLEY,
            ],
          },
        ],
      }),
        // END RADAR CHART SECTION
        (this.datacollection = {
          datasets: [
            {
              label: "50",
              steppedLine: false,
              backgroundColor: "#FF0000",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                this.stroke,
                "50",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "100",
              steppedLine: false,
              backgroundColor: "#FFA500",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                this.stroke,
                "100",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "200",
              steppedLine: false,
              backgroundColor: "#FFFF00",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                this.stroke,
                "200",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "400",
              steppedLine: false,
              backgroundColor: "#008000",
              fill: false,
              //hidden: true,
              data: this.getDataSet(
                this.athleteId,
                this.stroke,
                "400",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "800",
              steppedLine: false,
              backgroundColor: "#00FFFF",
              fill: false,
              //hidden: true,
              data: this.getDataSet(
                this.athleteId,
                this.stroke,
                "800",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "1500",
              steppedLine: false,
              backgroundColor: "#800080",
              fill: false,
              //hidden: true,
              data: this.getDataSet(
                this.athleteId,
                this.stroke,
                "1500",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
          ],
        }),
        (this.datacollectionFly = {
          datasets: [
            {
              label: "50",
              steppedLine: false,
              backgroundColor: "#FF0000",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "FLY",
                "50",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "100",
              steppedLine: false,
              backgroundColor: "#FFA500",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "FLY",
                "100",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "200",
              steppedLine: false,
              backgroundColor: "#FFFF00",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "FLY",
                "200",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
          ],
        }),
        (this.datacollectionBack = {
          datasets: [
            {
              label: "50",
              steppedLine: false,
              backgroundColor: "#FF0000",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "BACK",
                "50",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "100",
              steppedLine: false,
              backgroundColor: "#FFA500",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "BACK",
                "100",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "200",
              steppedLine: false,
              backgroundColor: "#FFFF00",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "BACK",
                "200",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
          ],
        }),
        (this.datacollectionBreast = {
          datasets: [
            {
              label: "50",
              steppedLine: false,
              backgroundColor: "#FF0000",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "BREAST",
                "50",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "100",
              steppedLine: false,
              backgroundColor: "#FFA500",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "BREAST",
                "100",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "200",
              steppedLine: false,
              backgroundColor: "#FFFF00",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "BREAST",
                "200",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
          ],
        }),
        (this.datacollectionIm = {
          datasets: [
            {
              label: "100",
              steppedLine: false,
              backgroundColor: "#FFA500",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "MEDLEY",
                "100",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "200",
              steppedLine: false,
              backgroundColor: "#FFFF00",
              fill: false,
              data: this.getDataSet(
                this.athleteId,
                "MEDLEY",
                "200",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
            {
              label: "400",
              steppedLine: false,
              backgroundColor: "#008000",
              fill: false,
              //hidden: true,
              data: this.getDataSet(
                this.athleteId,
                "MEDLEY",
                "400",
                this.facilityType,
                this.fromDate,
                this.toDate
              ),
            },
          ],
        });
      this.$router.replace({
        query: {
          facilityType: this.facilityType,
          athleteId: this.athleteId,
          fromDate: this.fromDate,
          toDate: this.toDate,
        },
      });
    },
  },
  mounted() {
    //this.fillData();
    //console.log(this.athleteOfficialResults);
    setTimeout(() => this.showResults(), 5000);
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
</style>
